<template>
    <div class="contact-result" >
	  	<div class="panel panel-default">
		    <div class="panel-heading dash-bg-color-skin-light-10">
	    		<div class="col-xs-2 pull-left align-left head-left">
            <div class="rec"></div>
	    			<i class="fa fa-chevron-left back-mb" aria-hidden="true" @click="toggle('list')"></i>
	    		</div>
	    		<div class="col-xs-8 pull-left align-center head-center">
	    			<div class="contactlabel"> {{ labels[nowLang].contactLabel }} </div>
	    		</div>
	    		<div class="col-xs-2 pull-right align-right">	    			
	    		</div>
	    	</div>
		    <div class="panel-body">
          <div class="back-for-pc cursor-pointer" v-show="pcDisp">
            <i class="fa fa-chevron-left" @click="toggle('list')"></i>
          </div>
			    <h2>{{ labels[nowLang].searchLabel }}</h2>				
					<div class="col-xs-12 col-ms-12 col-sm-12 col-md-12  ">
						<div class="form-group  border-input dash-border-color-skin">
						  <!-- <input :class="{ 'focus' : inputEmployee != '' }" v-model="inputEmployee" @keyup.enter="$refs.searchBtn.focus()">
						  <span>ชื่อ - นามสกุล</span> -->
						  <input v-model="inputEmployee" placeholder="employee name" ref="employee" @keyup.enter="$refs.searchBtn.focus()">
						  <!-- <multiselect v-model="employeeSelected" :options="fullname.rows" AllowEmpty placeholder="employee name" label="p_desc_codempid" track-by="codempid" select-label="Enter" ></multiselect> -->
					   </div>	
					</div> 
					<div class="col-xs-12 col-ms-12 col-sm-12 col-md-12">
						<div class="form-group border-input dash-border-color-skin">
						  <input v-model="inputCompany" placeholder="department" ref="company" @keyup.enter="$refs.position.focus()">
						  <!-- <multiselect v-model="companySelected" :options="company.rows" AllowEmpty placeholder="department" label="p_desc_codcomp" track-by="codcomp" select-label="Enter" ></multiselect> -->
					  </div>	
					</div>
					<div class="col-xs-12 col-ms-12 col-sm-12 col-md-12">
						<div class="form-group border-input dash-border-color-skin">
						  <input v-model="inputPosition" placeholder="position" ref="position" @keyup.enter="$refs.employee.focus()">
						  <!-- <multiselect v-model="positionSelected" :options="position.rows" AllowEmpty placeholder="position" label="p_desc_codpos" track-by="codpos" select-label="Enter" ></multiselect> -->
					  </div>	
					</div>    
	        <div class="align-center">
	        	<button type="button" class="btn btn_search dash-bg-color-skin-light-10" ref="searchBtn" @click="callSearch()">{{ labels[nowLang].search }}</button> 
	        	<button type="button" class="btn btn_search dash-bg-color-skin-light-10" ref="searchBtn" @click="callClear()">Clear</button> 
	        </div>
		    </div>
	  	</div>
	</div>
</template>

<script>
export default {
  name: 'contact-search',
  data () {
    return {
      // employeeSelected: { codempid: '', p_desc_codempid: '' },
      // companySelected: { codcomp: '', p_desc_codcomp: '' },
      // positionSelected: { codpos: '', p_desc_codpos: '' },
      inputCompany: '',
      inputEmployee: '',
      inputPosition: '',
      searchParams: {
        p_desc_codempid: '',
        p_desc_codcomp: '',
        p_desc_codpos: '',
        p_first_load: 'Y'
      }
    }
  },
  watch: {
    // 'employeeSelected.p_desc_codempid' (newVal) {
    //   this.searchParams.p_desc_codempid = (typeof newVal !== 'undefined') ? newVal : ''
    //   this.$emit('input', this.searchParams)
    // },
    // 'companySelected.p_desc_codcomp' (newVal) {
    //   this.searchParams.p_desc_codcomp = (typeof newVal !== 'undefined') ? newVal : ''
    //   this.$emit('input', this.searchParams)
    // },
    // 'positionSelected.p_desc_codpos' (newVal) {
    //   this.searchParams.p_desc_codpos = (typeof newVal !== 'undefined') ? newVal : ''
    //   this.$emit('input', this.searchParams)
    // },
    inputEmployee (newVal) {
      this.searchParams.p_desc_codempid = newVal
      this.$emit('input', this.searchParams)
    },
    inputCompany (newVal) {
      this.searchParams.p_desc_codcomp = newVal
      this.$emit('input', this.searchParams)
    },
    inputPosition (newVal) {
      this.searchParams.p_desc_codpos = newVal
      this.$emit('input', this.searchParams)
    }
  },
  methods: {
    callSearch () {
      this.searchParams.p_first_load = 'N'
      this.toggle('list')
      this.$emit('input', this.searchParams)
      this.$emit('enableTriggerResetBool')
    },
    callClear () {
      this.inputCompany = ''
      this.inputEmployee = ''
      this.inputPosition = ''
    }
  },
  props: [ 'labels', 'toggle', 'fullname', 'company', 'position', 'pcDisp', 'value', 'nowLang' ]
}
</script>

<style lang="scss">
/*.material-test{
	input {
	    height: auto;
	    width: 80%;
	    border-top:none;
	    border-left:none;
	    border-right:none;
	    border-bottom: 1px solid #e1e1e1;
	    padding: 5px;
	    box-sizing: border-box; 
	    margin-top:27px;
	    margin-bottom:10px;
	    margin-left:15px;
	    float:left;   

	    @media (min-width:360px) and (max-width:551px){
	         width: 85%;
	    }

	    @media (min-width:552px) and (max-width:768px){
	         width: 90%;
	    }
	}
	span {
	    position: relative;
	    float:left;
	    display: block;
	    top: -40px;
	    left: 45px;
	    color: #777777;
	    font-size: 16px;
	    line-height: 30px;
	    transition: .3s ease;
	}

	input:focus{
	    border-top:none;
	    border-left:none;
	    border-right:none;
	    border-bottom: 1px solid #2196f3;
	    outline: none;
	}

	input:focus + span,
	input.focus + span {
	    transform: translateY(-70%);
	    font-size: 12px;
	    color: #2196f3;
	}
}*/
</style>




// WEBPACK FOOTER //
// contactSearch.vue?5fe3bdd4